module.exports = __webpack_public_path__ + "static/media/Igglybuff_gaussian2.11b05b35.png";